/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { GamesEndpointUrl, perPage } from "../config/consts";
import Game from "./Game";
import { useTranslation } from "../hooks/hooks";
import {
    activeCategoryAtom,
    activeProvidersAtom,
    categoryTypeAtom,
    currentPageAtom,
    gamesAtom,
    sortOrderAtom,
} from "../state/games";
import { useAtom } from "jotai";
import { Button } from "@mui/material";
import { GamesCollection, IGame, IGamesRequest } from "../interfaces/intefaces";
import { createRequestJSON } from "../helpers/helpers";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { routes } from "../router/Routes";

const Games = () => {
    const { _e } = useTranslation();
    const [currentPage, setCurrentPage] = useAtom(currentPageAtom);
    const [activeCategory] = useAtom(activeCategoryAtom);
    const [categoryType] = useAtom(categoryTypeAtom);
    const [activeProvider] = useAtom(activeProvidersAtom);
    const [sortOrder] = useAtom(sortOrderAtom);
    const [games, setGames] = useAtom(gamesAtom);
    const [error, setError] = useState({ message: null });
    const location = useLocation();
    const params: IGamesRequest = {
        category_id: activeCategory,
        categoryType: categoryType,
        mobile: 1,
        forfun: undefined,
        lang: undefined,
        ct: 0,
        hot: location.pathname === routes.pages.hot ? 1 : 0,
        new: location.pathname === routes.pages.new ? 1 : 0,
        cp: currentPage,
        ps: perPage,
        prs: activeProvider,
    };
    const dataToSubmit = createRequestJSON(params);

    const sortAndSetGames = (games: GamesCollection) => {
        if (sortOrder === "asc") {
            const sortedGames = games.games.sort((a: IGame, b: IGame) => a.pt.localeCompare(b.pt));
            setGames({
                games: sortedGames,
                count: games.count,
            });
        } else {
            setGames(games);
        }
    };
    useEffect(() => {
        const fetchGames = async (callback: any, errorCallback: any) => {
            const url = GamesEndpointUrl;
            const returnedData = await axios
                .get(url, { params: dataToSubmit })
                .then(res => res.data.data)
                .catch(error => errorCallback(error.toJSON()));
            callback(returnedData);
        };
        fetchGames(sortAndSetGames, setError);
    }, [activeCategory, categoryType, activeProvider, sortOrder]);

    return (
        <>
            <div className="games-inner">
                <div className="games">
                    {games !== null &&
                        games.games.slice(0, (currentPage + 1) * perPage).map(game => {
                            return <Game game={game} key={game.id} />;
                        })}
                </div>

                {games && (currentPage + 1) * perPage <= games.count && (
                    <div className="text-center">
                        <Button
                            sx={{
                                margin: "50px 0",
                            }}
                            variant="outlined"
                            type="button"
                            className="btn-primary load_more"
                            onClick={() => {
                                setCurrentPage(currentPage + 1);
                            }}
                        >
                            {_e("Load more")}
                        </Button>
                    </div>
                )}

                {games && games.games.length == 0 && (
                    <div className="no-results text-center">{_e("No results found")}</div>
                )}
            </div>
        </>
    );
};

export default Games;
